import { FC } from "react";

const Time: FC = () => {
  return (
    <>
      <svg
        className="min-w-24px"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.991 3C7.023 3 3 7.032 3 12C3 16.968 7.023 21 11.991 21C16.968 21 21 16.968 21 12C21 7.032 16.968 3 11.991 3ZM12 19.2C8.022 19.2 4.8 15.978 4.8 12C4.8 8.022 8.022 4.8 12 4.8C15.978 4.8 19.2 8.022 19.2 12C19.2 15.978 15.978 19.2 12 19.2ZM12.45 8.175C12.45 7.80221 12.1478 7.5 11.775 7.5C11.4022 7.5 11.1 7.80221 11.1 8.175V12.9L15.2744 15.4047C15.5791 15.5875 15.9743 15.4902 16.1593 15.1868C16.3468 14.8793 16.2469 14.4778 15.9371 14.294L12.45 12.225V8.175Z"
          fill="black"
        />
      </svg>
    </>
  );
};

export default Time;
